import { combineReducers } from "redux";
import { CarritoMex } from "../reducersMex/rCarrito";
import { CatalogosMex } from "../reducersMex/rCatalogos";
import cotizacionReducer from "./cotizacion.reducer";
import detallePolizaReducer from "./detallePoliza.reducer";
import EmisionAseguradosReducer from "./emision/asegurados.reducers";
import EmisionCatalogosReducer from "./emision/catalogos.reducers";
import ParametrosPagoReducer from "./parametrosPago.reducer";
import { datosUsuarios } from "./rlogin";

export default combineReducers({
  datosUsuarios,

  //Reducer Mexico
  CatalogosMex,
  CarritoMex,
  cotizacionReducer,
  detallePolizaReducer,
  ParametrosPagoReducer,
  EmisionAseguradosReducer,
  EmisionCatalogosReducer,
});
